// src/pages/fire/hooks/useDocumentLookup.ts

import { FormHandles } from "@unform/core";
import { useRef, useState } from "react";
import { useToast } from "../../../shared/hooks";
import { PeopleService } from "../../../shared/services/api/people/PeopleService";

export function useDocumentLookup(formRef: React.RefObject<FormHandles>) {
	const toastHandler = useToast();
	const [isLoading, setLoading] = useState(false);
	const normalizeCpf = (s: string) => (s || "").replace(/\D+/g, "");

	// Usar um cache para cada tipo de documento (inquilino/locador)
	const lastSearchedDocumentsRef = useRef<Record<string, string | null>>({
		tenant: null,
		lessor: null,
	});

	const handleDocumentLookup = async (document: string, prefix: "tenant" | "lessor") => {
		const normalizedDocument = normalizeCpf(document);

		// Verifica se o documento atual é o mesmo do último pesquisado para este prefixo
		if (normalizedDocument === lastSearchedDocumentsRef.current[prefix]) {
			return;
		}

		if (!document || normalizedDocument.length !== 11) {
			lastSearchedDocumentsRef.current[prefix] = null;
			return;
		}

		try {
			setLoading(true);
			const data: any = await PeopleService.getPersonDataByDocument(normalizedDocument);
			const name = data?.naturalPersonData?.name || data?.legalPersonData?.name || data?.name || null;

			if (name) {
				// Armazena o documento pesquisado com sucesso no cache
				lastSearchedDocumentsRef.current[prefix] = normalizedDocument;

				// Usa o prefixo para definir os campos dinamicamente
				formRef.current?.setFieldValue(`${prefix}Name`, name);

				// O campo de Data de Nascimento existe apenas para pessoa física
				if (data.naturalPersonData?.birthDate) {
					formRef.current?.setFieldValue(`${prefix}BirthDate`, data.naturalPersonData.birthDate);
				}
			}
			return name;
		} finally {
			setLoading(false);
		}
	};

	return { handleDocumentLookup, isLoading };
}
